/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"LoyaltyButton":"LoyaltyButton_eocHS","button":"button_kNMjv","customIcon":"customIcon_iTh6Y","scoreLabel":"scoreLabel_4PkcV"};